<!--设备属性配置-->
<template>
  <Row>
    <packageTable
      ref="contentBaseRef"
      :tableData="tableDataList"
      :columnsData="columnsData"
      :border="true"
      :loading="tableLoading"
      :tabletotallen="getPageTotal"
      :reduceheight="reduceheight"
      :tablePageSize="reqBase.page_size"
      :showSearchBtn="false"
      @pageonChange="pageonChange"
      @pageSizeChange="pageSizeChange"
      @refreshBtn="init"
      @showSearchParel="showSearchParel">
      <template slot="headLeft">
        <Form ref="formInline" :model="form_filter" class="tableHeaderForm"
              @keydown.enter.native="search" inline>
          <FormItem label="">
            <Input type="text" v-model="form_filter.admin_real_name" style="width:110px" placeholder="用户名称筛选"></Input>
          </FormItem>
          <!-- <FormItem label="采购单价">
            <Input type="text" v-model="form_filter.purchase_price" style="width:110px" placeholder="采购单价"></Input>
          </FormItem>
          <FormItem label="	税率">
            <Input type="text" v-model="form_filter.rate" style="width:110px" placeholder="100以下，1表示1%"></Input>
          </FormItem> -->
          <FormItem class="reduceFromMarginLeft">
            <Button v-for="(item,index) in headBtnList" @click="item.method" :key="index" class="base_btn_item"
                    :type="item.type" :icon="item.icon">{{item.name}}</Button>
          </FormItem>
        </Form>
        </template>
        <template slot="headRight">
          <Tooltip v-for="(item,index) in topButtonList1" v-if="functionRole.indexOf(item.key)>-1" :key="index"  :content="item.name" placement="bottom">
              <Button  
                  :type="item.type"      
                  style="margin-right: 5px;" 
                  @click="item.method" 
                  :key="index" 
                  :icon="item.icon"></Button>
          </Tooltip>
        </template>
    </packageTable>
  </Row>
</template>
<script>
  import packageTableMixins from '@/mixins/packageTableMixins.js'
  import addCom from './components/addCom'
  // import deviceTypeDetails from './components/deviceTypeDetails'
  import {getadminlist,admin_del,adduser,admin_update,change_adminstatus} from '@/api/auth'
  export default {
    name: 'diviceAttrConfig',
    mixins: [packageTableMixins],
    data () {
      return {
        functionRole:[],
        form_filter:{
          admin_real_name:null,
          purchase_price:null,
          rate:null
        },
        admin_statusList:[
          {
            value:0,
            color:'error',
            label:'禁用'
          },
          {
            value:1,
            color:'success',
            label:'启用'
          }
        ],
        headBtnList: [
          {
            name: '查询',
            type: 'primary',
            method: this.search
          },
          {
            name: '重置',
            type: 'error',
            method: this.reset
          },
        ],
        topButtonList1:[
          // {
          //   name:'重置',
          //   type:'error',
          //   method:this.reset
          // },
          {
            name:'新增',
            icon:'ios-add',
            type:'primary',
            method:this.add,
            key:'adduser',
          },
          {
            name:'刷新',
            icon:'ios-refresh',
            type:'primary',
            method:this.init,
            key:'getadminlist',
          }
        ],
        operationButtonList:[
          {
            name:'编辑',
            type:'text',
            key:'admin_update',
            method:this.edit
          },
          {
            name:'删除',
            type:'text',
            icon:'',
            key:'admin_del',
            method:this.del
          },
          {
            name:'启用',
            type:'text',
            show:[0],
            key:'change_adminstatus',
            method:this.handleUpper
          },
          {
            name:'禁用',
            type:'text',
            show:[1],
            key:'change_adminstatus',
            method:this.handleUpper
          }
        ],
        columnsData: [
          // {
          //   title: '序号',
          //   key: 'xuhao',
          //   width:100,
          //   align: 'center'
          // },
          {
            title: '手机号',
            key: 'admin_name',
            align: 'center'
          },
          {
            title: '用户名称',
            key: 'admin_name',
            align: 'center'
          },
          {
            title: '企业名称',
            key: 'company_code',
            align: 'center'
          },
          {
            title: '状态',
            key: 'admin_status',
            align: 'center',
            render:(h,{row})=>{
              let result=''
              let color=''
              for(let i=0;i<this.admin_statusList.length;i++){
                let item=this.admin_statusList[i]
                if(item.value===row.admin_status){
                  result=item.label;
                  color=item.color;
                  break;
                }
              }
              return h('Tag',{
                props:{
                  color:color
                }
              },result)
            }
          },
          {
            title: '角色',
            key: 'group_names',
            align: 'center'
          },
          // {
          //   title: '创建日期',
          //   key: 'addtime',
          //   align: 'center'
          // },
          {
            title: '操作',
            key: 'name',
            align: 'center',
            render: (h, { row }) => {
              let arr=[];
              for(let i in this.operationButtonList){
                let list=this.operationButtonList[i];
                if(list.hasOwnProperty('show') && this.functionRole.indexOf(list.key)>-1){
                  if(list.show.indexOf(row.admin_status)>-1){
                    arr.push(h('Button',{
                      style:{marginLeft:'5px',color:'#2d8cf0'},
                      props:{
                        type:list.type,
                        size:list.size?list.size:'small'
                      },
                      on:{
                        click:()=>{
                          list.method(row,list.name)
                        }
                      }
                    },list.name));
                  }
                }else{
                  if(this.functionRole.indexOf(list.key)>-1){
                    arr.push(h('Button',{
                      style:{marginLeft:'5px',color:'#2d8cf0',},
                      props:{
                        type:list.type,
                        size:list.size?list.size:'small'
                      },
                      on:{
                        click:()=>{
                          list.method(row)
                        }
                      }
                    },list.name));
                  }
                  
                }
              }
              return h('div',arr)
            }
          },
        ],
        reqBase: {
          page: 1
        },
        tableDataList:[]
      }
    },
    components: {},
    computed: {
      
    },
    methods: {
      search(){
        this.onSearch(this.form_filter);
      },
      reset(){
        this.form_filter={
          admin_real_name:null,
          purchase_price:null,
          rate:null
        };
        this.search();
      },
      showSearchParel(){
        this.$refs.searchPanelRef.expandPanel();
      },
      init () {
        // this.getPageSizeToStorage();
        this.tableLoading=true;
        this.tableDataList =[];
        let params = this.reqBase,
          callback = res => {
            this.tableLoading=false;
            if (res.result === 0) {
              this.tableDataList = res.body.list||[];
              this.getPageTotal=res.body.total;
            } else {
              this.tableDataList =[];
              this.getPageTotal=0;
              this.$Message.error(res.errorMsg)
            }
          }
        getadminlist(params).then(res => {
          callback(res)
        })
      },
      add(){
        const vm = this
        let config = {
          loading: true,
          width: 500,
          render: (h) => {
            return h('div', [
              h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
                h('h3', { style: { width: '100%', paddingBottom: '15px' } }, '新增'),
                h('icon', {
                  props: { type: 'md-close', size: '16' },
                  style: {
                    cursor: 'pointer'
                  },
                  on: {
                    'click': evt => {
                      vm.$Modal.remove()
                    }
                  }
                })
              ]),
              h('Divider',{style:{margin:0}}),
              h(addCom, {
                ref: 'addCom',
                props: {
                  edit:false,
                  $store: this.$store
                }
              })
            ])
          },
          onOk: function () {
            let _this=this;
            let obj=this.$refs.addCom;
            obj.checkForm().then(r=>{
              if(r){
                let data=obj.formValidate;
                adduser(data).then(res=>{
                  let msg=res.errorMsg;
                  if(res.result===0){
                    vm.$Message.success(msg);
                    vm.init();
                    vm.$Modal.remove();
                  }else{
                    _this.buttonLoading = false
                    vm.$Message.error(msg);
                  }
                });
              }else{
                _this.buttonLoading = false
              }
            });
          },
        }
        vm.$Modal.confirm(config)
      },
      /**
       * 详情
       */
      details (row) {
        const vm = this
        let config = {
          loading: true,
          width: 1000,
          okText:'关闭',
          render: (h) => {
            return h('div', [
              h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
                h('h3', { style: { width: '100%', paddingBottom: '15px' } }, '详细信息'),
                h('icon', {
                  props: { type: 'md-close', size: '16' },
                  style: {
                    cursor: 'pointer'
                  },
                  on: {
                    'click': evt => {
                      vm.$Modal.remove()
                    }
                  }
                })
              ]),
              h('Divider',{style:{margin:0}}),
              h(deviceTypeDetails, {
                ref: 'deviceTypeDetails',
                props: {
                  edit:false,
                  setData: row,
                  $store: this.$store
                }
              })
            ])
          },
          onOk: function () {
            vm.$Modal.remove()
          }
        };
        this.$Modal.success(config)
      },
      edit(row){
        const vm = this
        let config = {
          loading: true,
          width: 500,
          render: (h) => {
            return h('div', [
              h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
                h('h3', { style: { width: '100%', paddingBottom: '15px' } }, '编辑'),
                h('icon', {
                  props: { type: 'md-close', size: '16' },
                  style: {
                    cursor: 'pointer'
                  },
                  on: {
                    'click': evt => {
                      vm.$Modal.remove()
                    }
                  }
                })
              ]),
              h('Divider',{style:{margin:0}}),
              h(addCom, {
                ref: 'addCom',
                props: {
                  edit:true,
                  setData:row,
                  $store: this.$store
                }
              })
            ])
          },
          onOk: function () {
            let _this=this;
            let obj=this.$refs.addCom;
            obj.checkForm().then(r=>{
              if(r){
                let {admin_id,admin_name,admin_real_name,admin_password,group_codes,company_name}=obj.formValidate;
                admin_update({admin_id,admin_name,admin_real_name,admin_password,group_codes,company_name}).then(res=>{
                  let msg=res.errorMsg;
                  if(res.result===0){
                    vm.$Message.success(msg);
                    vm.init();
                    vm.$Modal.remove();
                  }else{
                    _this.buttonLoading = false
                    vm.$Message.error(msg);
                  }
                });
              }else{
                _this.buttonLoading = false
              }
            });
          }
        }
        vm.$Modal.confirm(config)
      },
      handleUpper(row,name){
        let vm=this;
        let config={
          title:name,
          loading:true,
          content:'您真的想'+name+'这个帐号吗？',
          onOk:function(){
            let _this=this;
            change_adminstatus({admin_id:row.admin_id}).then(res=>{
              let msg=res.errorMsg;
              if(res.result===0){
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init();
              }else{
                _this.buttonLoading=false;
                vm.$Message.error(msg);
              }
            });
          }
        }
        this.$Modal.confirm(config)
      },
      /**
       * 删除
       * @param row
       */
      del(row){
        let vm=this;
        let title='帐号信息'
        let config={
          title:'删除'+title,
          loading:true,
          content:'您真的想删除这个"'+row.user_name+'"吗？',
          onOk:function(){
            let _this=this;
            admin_del({admin_id:row.admin_id}).then(res=>{
              let msg=res.errorMsg;
              if(res.result===0){
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init();
              }else{
                _this.buttonLoading=false;
                vm.$Message.error(msg);
              }
            });
          }
        }
        this.$Modal.confirm(config)
      }
    },
    mounted () {
      //获取相应权限
      this.getFunctionRole()
      console.log(this.functionRole)
      this.init();
    },
    created () {
      
    }
  }
</script>

<style scoped>
  .w6, .w24 {
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
  }

  .w24 {
    width: calc(100% - 10px);
  }

  .w6 {
    width: calc(25% - 10px);
  }
</style>
